<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="shadow">
          <template v-slot:body>
            <h4>Request Mail</h4><br>
            <b v-if="parentMailObj.message_subject || vmSendReplyMailFormData.custom_subject"><span>Subject:&nbsp;</span>{{parentMailObj.message_subject ? parentMailObj.message_subject : vmSendReplyMailFormData.custom_subject}}</b>
            <div style="background-color: whitesmoke;"><vue-editor v-if="parentMailObj.text_mess" v-model="parentMailObj.text_mess" disabled></vue-editor></div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <hr style="border: none;height: 2px; background-color: #e5252c; margin: 1rem 0; border-radius: 9999px;" />

    <b-row>
      <b-col lg="12">
        <iq-card class="shadow">
          <template v-slot:body>
            <h4>Response Mail</h4>
            <form action="#" v-if="vmSendReplyMailFormData && Object.keys(vmSendReplyMailFormData).length > 0" key="vmSendReplyMailFormData">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationsession_user_name">{{cvSendMailUserNameLabel}}</label>
                  <input v-model="replyMailObj.user_name" type="text" class="form-control" required disabled/>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationsession_user_email">{{cvSendMailUserEmailLabel}}</label>
                  <input v-model="replyMailObj.user_email" type="text" class="form-control" required disabled/>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationsession_parent_email">To</label>
                  <input v-model="vmSendReplyMailFormData.user_email" type="text" class="form-control" required />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationsession_parent_email">{{cvSendMailParentEmailLabel}}</label>
                  <input v-model="vmSendReplyMailFormData.cc_email" type="text" class="form-control" required/>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationsession_subject">{{"Subject"}}</label>
                  <input v-model="vmSendReplyMailFormData.custom_subject" type="text" class="form-control" required/>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationsession_message">Response Editor</label>
                  <vue-editor v-model="vmSendReplyMailFormData.custom_message"></vue-editor>
                </div>
              </div>

              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary mr-2" @click="sendMail()">{{cvSubmitBtn}}</button>
                <button type="button" class="btn btn-primary" @click="ChatMessageEdit()">{{cvSaveBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { ChatMessages } from "../FackApi/api/ChatMessage.js"
import ApiResponse from "../Utils/apiResponse"
import { SendMail } from "../FackApi/api/sendMail.js"
import GideProducts from "../FackApi/json/GideProducts.json"
import { VueEditor } from "vue2-editor"

export default {
  name: "SendMailReply",
  components: {
    VueEditor
  },
  props: {
    propreplyMailObj: {
      type: Object,
      default: function () {
        return {
          "user_name": "",
          "user_email": "",
          "cc_email": "",
          "message_subject": "",
          "text_mess": "",
          "message_id": null
        }
      }
    },
    propModuleName: {
      type: String,
      default: "gpaths"
    }
  },
  data () {
    return {
      GideProducts: GideProducts,
      cvSubmitBtn: "Send Mail",
      cvSendMailUserNameLabel: "From User",
      cvSendMailUserEmailLabel: "From Email Id",
      cvSendMailParentEmailLabel: "CC",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Send Mail Response",
      vmSendReplyMailFormData: {},
      module_name: null,
      replyMailObj: null,
      parentMailObj: {},
      ChatMessageData: null,
      cvSaveBtn: "Save"
    }
  },
  async mounted () {
    this.module_name = this.propModuleName
    this.replyMailObj = this.buildMailObj(this.propreplyMailObj)
    this.parentMailObj = await this.chatMessageView(this.propreplyMailObj.message_id)
    this.vmSendReplyMailFormData = this.initFormData(this.replyMailObj, this.parentMailObj)
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSendReplyMailFormData) {
          if (!this.vmSendReplyMailFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * chat Message View - get user data
     */
    async chatMessageView (messageId) {
      let ChatMessageData = { this_message_id: messageId }
      let ChatMessageViewResp = await ChatMessages.ChatMessageViewConsole(this, ChatMessageData)
      if (ChatMessageViewResp && ChatMessageViewResp.resp_status) {
        this.ChatMessageData = ChatMessageViewResp.resp_data.data
        return this.buildMailObj(this.ChatMessageData)
      }
      return null
    },
    /**
     * build Mail Obj
     */
    buildMailObj (chatData) {
      return {
        user_id: chatData.user_id,
        user_name: chatData.user_name,
        user_email: chatData.user_email,
        text_mess: chatData.text_msg,
        message_subject: chatData.message_subject,
        date: chatData.created_on,
        this_message_id: chatData.message_id
      }
    },
    /**
     * initFormData
     */
    initFormData (replyMailObj, parentMailObj) {
      const receivedMessage = parentMailObj?.text_mess || ""
      const sentMessage = replyMailObj.text_mess || ""
      const dateValue = parentMailObj?.date ? new Date(parentMailObj.date) : new Date()
      const formattedDate = new Intl.DateTimeFormat("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "numeric", minute: "2-digit", hour12: true }).format(dateValue)

      let combinedMessage =
      `<p style="white-space-collapse: break-spaces;">${sentMessage ? sentMessage + "<br>" : ""}</p>` +
      `<hr style="margin:0px;">` +
      `<p style="color:gray; font-style:italic; white-space-collapse: break-spaces;">On ${formattedDate}, ${parentMailObj.user_name} &lt;<a href="mailto:${parentMailObj.user_email}">${parentMailObj.user_email}</a>&gt; wrote:</p>` +
      `<p style="white-space-collapse: break-spaces;">${receivedMessage}</p>`

      return {
        user_id: parentMailObj.user_id,
        user_name: parentMailObj.user_name,
        user_email: parentMailObj.user_email,
        cc_email: parentMailObj.cc_email,
        custom_subject: replyMailObj.message_subject,
        custom_message: combinedMessage,
        this_message_id: replyMailObj.this_message_id,
        reply_email: replyMailObj.text_mess,
        send_email_from_domain: this.propreplyMailObj.app_domain
      }
    },
    /**
     * send Mail
     */
    async sendMail () {
      try {
        this.cvLoadingStatus = true

        const sendMailResp = await SendMail.sendMailToUser(this, this.vmSendReplyMailFormData)
        if (sendMailResp.resp_status) {
          this.$emit("emitCloseSendMailModal")
        }
        ApiResponse.responseMessageDisplay(this, sendMailResp)

        this.ChatMessageEdit(true)
      }
      catch (err) {
        console.error("Exception occurred at sendMailToUser() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * ChatMessageEdit
     */
    async ChatMessageEdit (isReplyDelivered = false) {
      try {
        this.cvLoadingStatus = true
        this.vmSendReplyMailFormData.this_message_id = this.propreplyMailObj.this_message_id

        this.vmSendReplyMailFormData.text_msg = this.vmSendReplyMailFormData.custom_message
        this.vmSendReplyMailFormData.message_subject = this.vmSendReplyMailFormData.custom_subject

        if (isReplyDelivered) {
          this.vmSendReplyMailFormData.isReplyDelivered = 1
        }

        let ChatMessageAddResp = await ChatMessages.ChatMessageEdit(this, this.vmSendReplyMailFormData)
        await ApiResponse.responseMessageDisplay(this, ChatMessageAddResp)
        if (ChatMessageAddResp.resp_status) {
          this.$emit("emitCloseSendMailModal")
        }
      }
      catch (err) {
        console.error("Exception occurred at ChatMessageEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  },
  watch: {
    propreplyMailObj: {
      deep: true,
      handler (newVal) {
        if (newVal && newVal.text_mess) {
          this.replyMailObj.text_mess = newVal.text_mess
          if (this.vmSendReplyMailFormData) {
            this.vmSendReplyMailFormData.reply_email = newVal.text_mess
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.shadow{
  box-shadow: none !important;
}
</style>
